import { GetStaticPaths, GetStaticProps, GetStaticPropsResult } from 'next';

import type { LegalPageSellersType } from '#__generated__/sanity';
import { Page } from '#components/pages/legal.[slug]/Page';
import { sanityClient } from '#utils/sanity';

type Props = {
  page: LegalPageSellersType;
};

type Slug = LegalPageSellersType['slug'];

export const getStaticPaths: GetStaticPaths = async () => {
  const slugs = await sanityClient.fetch<{ slug: Slug }[]>(
    `*[_type == 'legalPageSellers'] { slug }`,
  );
  const paths = slugs.map(({ slug }) => ({
    params: { slug: slug.current },
  }));

  return {
    paths,
    fallback: true,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const REVALIDATE_SECONDS = 60;
  const notFoundProps: GetStaticPropsResult<Props> = {
    notFound: true,
    revalidate: REVALIDATE_SECONDS,
  };

  if (!params) {
    return notFoundProps;
  }

  const page = await sanityClient.fetch<LegalPageSellersType>(
    `*[_type == "legalPageSellers" && slug.current == '${params.slug}'][0]`,
  );
  if (!page) {
    return notFoundProps;
  }

  return {
    props: { page },
    revalidate: REVALIDATE_SECONDS,
  };
};

export default Page;
